import { CircularProgress, Modal } from '@mui/material';
import styled, { useTheme } from 'styled-components';

import { useLoadingStore } from 'store/loadingStore';
import { useModalStackStore } from 'store/modalStackStore';

/**
 * ModalStackProvider는 ModalStackStore에서 관리하는 Modal Stack를 렌더링합니다.
 */
export default function ModalStackProvider() {
  const { stack, closeModal } = useModalStackStore();
  const { checkIsMutationing } = useLoadingStore();
  const theme = useTheme();

  return (
    <>
      {stack.map(({ element, modalActionProps }, index) => {
        const loadingKey = modalActionProps?.loading?.key;
        const isLoading = checkIsMutationing(loadingKey);

        return (
          <Modal
            key={'modal-provider' + index}
            open
            onClose={(_, reason) => {
              if (isLoading) {
                return;
              }
              if (!modalActionProps?.closeOnBackdropClick) {
                if (reason !== 'backdropClick') {
                  closeModal();
                }
              } else {
                closeModal();
              }
            }}
          >
            <>
              <ModalWrapper className="modal-content" style={{ ...modalActionProps?.modalWrapperStyle }}>
                {element}
              </ModalWrapper>
              {isLoading && (
                <SDropBack>
                  <SLoadingWrapper>
                    <CircularProgress sx={{ color: theme.color.static.primary }} />
                  </SLoadingWrapper>
                </SDropBack>
              )}
            </>
          </Modal>
        );
      })}
    </>
  );
}

const SDropBack = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.7;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SLoadingWrapper = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.color.field.background};
`;

const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.color.popup.background};
  border-radius: 12px;
  width: 80%;
  max-width: 400px;

  @media ${({ theme }) => theme.device.small} {
    width: 90%;
    /* max-width: 340px; */
  }
`;
